import {System} from "../../data/data-class/system/systemClass";
import ViaqTryCatch from "../../services/GlobalTryCatch";
import axiosInstance from "../../services/axios";

class SystemRepository {
    static async getdata(text, pageNumber) {
        const data = {
            text: text.trim(),
            pageNumber: pageNumber,
        };
        // const data_ = await postRequestWithToken("/system", data);
        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/system", data)
            });


    }

    static async delete(id) {
        const data = {
            id: id,
        };
        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/system/delete", data)
            });

    }

    static async configPrice(data) {
        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/system/edit-price", data)
            });


    }

    static async add(count, token) {
        // const orderid = await postRequestWithToken("/system/add", id);

        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/system/add", count)
            });


    }

    static async updateApplication(data) {
        return await ViaqTryCatch(
            function () {
                return axiosInstance.post("/system/set-release", {
                        "number": data.version,
                        "force": data.isForce
                    }
                )
            });
    }
}

export {SystemRepository};
